/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosRequestConfig, Method } from 'axios';

// base

export interface CacheConfig {
  [key: string]: CacheConfigItem;
}

export interface CacheConfigItem {
  url: string;
  method: Method;
  baseURL?: string;
  requestType?: string;
  showLoading?: boolean;
  source?: REQUEST_SOURCE;
  format?: Format<any, any>;
  filter?: Filter<any, any, any>;
}

export interface Format<T, U> {
  (value: T): U;
}

export interface Filter<T, U, P> {
  (value: RequestOption<T, U>): P;
}

export interface Params {
  t?: number;
}

export interface RequestOption<T, U> {
  data?: T;
  params?: U;
  headers?: {
    [key: string]: any;
  };
  polling?: {
    timeInterval: number;
  };
}

export interface RequestConfig extends RequestOption<any, any> {
  polling?: {
    timeInterval: number;
  };
}

export interface RequestWithCacheOption<T, U> {
  data?: T;
  params?: U;
}

// api

// export interface DataCenter {
//   data: {
//     [key: string]: any;
//   };
//   set: (key: string, data: any) => void;
//   get: (key: string) => any;
//   clear: (key: string) => void;
// }

export enum RESPONSE_CODE {
  CORRECT = 0,
  UN_LOGIN = 401,
  PERMISSION_DENIED = 403,
  TIMEOUT = 416, // 接口访问超时，退登使用
  PARAM_ERROR = 417, // 参数请求错误
  SERVER_ERROR = 500,
  ACCOUNT_CANCELLATION = 802, // 账号已注销
  NOT_READY = 842, // 未就绪(当用户升级app后没有重新登录，在注销账号时会遇到获取accessToken失败的情况，需要用户手动退出后重新登录才可)
  MODAL = -2,
  NOTIFY = -3, // 一开始文档中约定的数值，一直未使用
  TOAST = -1, // 后端实际使用的数值，已和app端使用过
}

export interface Response<D> {
  code: RESPONSE_CODE;
  message: string;
  result: D;
}

export interface ErrorResponseHandler {
  [RESPONSE_CODE.UN_LOGIN]?: () => void;
  [RESPONSE_CODE.PERMISSION_DENIED]?: () => void;
  [RESPONSE_CODE.SERVER_ERROR]?: () => void;
  [RESPONSE_CODE.MODAL]?: (message: string) => void;
  [RESPONSE_CODE.NOTIFY]?: (message: string) => void;
  [RESPONSE_CODE.TIMEOUT]?: () => void;
  [RESPONSE_CODE.PARAM_ERROR]?: () => void;
}

export enum REQUEST_SOURCE {
  PANDA,
  YOUDAO
}

export interface YoudaoResponse<D> {
  code: number;
  msg: string;
  data: D;
  status: number;
}

export interface ExportResponse {
  totalPage: number;
  currentPage: number;
  downloadUrl: string;
}

export interface BuryParameters {
  page_referrer?: string;
  dialog_status?: string;
  album_id?: number;
  product_id?: number;
  trace_name?: string;
  url?: string;
  subject?: string;
}
export enum TRUE_AND_FALSE {
  FALSE,
  TRUE
}

export type NumberTypeMap = {
  [key: number]: string;
}

export type StringTypeMap = {
  [key: string]: string;
}
